import config from '../config.json';
import packageDef from '../package.json';

export default {
  ...Object.assign({ version: packageDef.version }, config['common'], config['accounts'])
};
